/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiProjectInputFromJSON, ApiProjectInputToJSON, } from './ApiProjectInput';
export function ApiNewProjectRequestFromJSON(json) {
    return ApiNewProjectRequestFromJSONTyped(json, false);
}
export function ApiNewProjectRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'project': !exists(json, 'project') ? undefined : ApiProjectInputFromJSON(json['project']),
        'subscriptionId': !exists(json, 'subscriptionId') ? undefined : json['subscriptionId'],
        'trialDays': !exists(json, 'trialDays') ? undefined : json['trialDays'],
    };
}
export function ApiNewProjectRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'clientId': value.clientId,
        'email': value.email,
        'name': value.name,
        'project': ApiProjectInputToJSON(value.project),
        'subscriptionId': value.subscriptionId,
        'trialDays': value.trialDays,
    };
}
